import { observer } from 'mobx-react-lite'
import { useRouteError } from 'react-router'
import { useFeatures } from '@/contexts/root-store-context'
import { MobileJobRootContainer } from './MobileJobRootContainer'

/**
 * Shows a job that failed to load in place of the job.
 */
export default observer(function MobileJobErrorBoundaryContainer() {
  const error = useRouteError()
  const { internal } = useFeatures(({ jobs }) => ({
    internal: jobs.internal(),
  }))

  return (
    <MobileJobRootContainer
      rootVm={internal.jobRootViewModel}
      data={null}
      error={error}
    />
  )
})
